import { render, staticRenderFns } from "./OnboardingSharedCardTerms.vue?vue&type=template&id=e3f30aba&"
import script from "./OnboardingSharedCardTerms.vue?vue&type=script&lang=js&"
export * from "./OnboardingSharedCardTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports